import type {BioIconProps} from '../../icons/common-types'
import {FlagIconsUS} from '../../icons/flag-icons-us'

export default function EagleReviewsLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          d="M29.3331 7.61333V20.3867C29.3331 24.0667 26.3464 27.0533 22.6664 27.0533H9.3331C8.71977 27.0533 8.1331 26.9733 7.55977 26.8133C6.7331 26.5867 6.46643 25.5333 7.07977 24.92L21.2531 10.7467C21.5464 10.4533 21.9864 10.3867 22.3998 10.4667C22.8264 10.5467 23.2931 10.4267 23.6264 10.1067L27.0531 6.66666C28.3064 5.41333 29.3331 5.82666 29.3331 7.61333Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M19.5203 9.81336L5.56033 23.7734C4.92033 24.4134 3.85366 24.2534 3.42699 23.4534C2.93366 22.5467 2.66699 21.4934 2.66699 20.3867V7.61336C2.66699 5.82669 3.69366 5.41336 4.94699 6.66669L8.38699 10.12C8.90699 10.6267 9.76033 10.6267 10.2803 10.12L15.0537 5.33336C15.5737 4.81336 16.427 4.81336 16.947 5.33336L19.5337 7.92003C20.0403 8.44003 20.0403 9.29336 19.5203 9.81336Z"
          fill="white"
        />
      </svg>
      <span>Eagle Reviews</span>
      <FlagIconsUS className="absolute -right-6 -top-3 size-8 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5" />
    </div>
  )
}
